export default [
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("../pages/orderList/orderList"),
    meta: { title: "订单列表", keepAlive: true }
  }
];
